<script>
    import {mapState, mapGetters} from 'vuex'

    export default {
        data() {
            return {};
        },
        methods: {},
        computed: {
            ...mapState('user/events', {
                items: 'items',
            }),
            ...mapGetters({
                permission: 'permission',
            }),
        },
        mounted() {
        }
    };
</script>

<template>
    <a class="mag-header-events" href="/tourclient/admin/events/index.html" v-if="permission(310)">
        <i class="mag-icon-nav-top-alarm"></i>
        <div class="mag-header-events__badge" v-show="items">{{items}}</div>
    </a>
</template>

<style lang="scss">
    .mag-header-events {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 40px;
        font-size: 20px;
        text-decoration: none;
        cursor: pointer;
        &__badge {
            position: absolute;
            top: 2px;
            right: 2px;
            background: #e78374;
            color: #fff;
            padding: 0 4px;
            font-size: 9px;
            height: 15px;
            min-width: 15px;
            line-height: 15px;
            border-radius: 10px;
            text-align: center;
        }
    }
</style>
